








import { Component, Vue } from 'vue-property-decorator';



@Component
export default class Home extends Vue {
  public selectedValue: any = {
    start: new Date(2019, 0, 25),
    end: new Date(2019, 0, 28),
  };
  public formats: any = {
    title: 'MMMM YYYY',
    weekdays: 'W',
    navMonths: 'MMM',
    input: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'], // Only for `v-date-picker`
    dayPopover: 'L', // Only for `v-date-picker`
    data: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'], // For attribute dates
  };
}
